// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectBuildingTypeQueryResult, selectBuildingTypesPageLoading, selectBuildingTypesShowInitWaitingMessage} from '../_selectors/building-type.selectors';

export class BuildingTypesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectBuildingTypesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectBuildingTypesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectBuildingTypeQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
